import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { getLandingRouteForUser } from "../lib/roleRouting";

export const ProtectedRoute = ({ children, area }) => {
  const { user, checking } = useAuth();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-checking">
        <p className="text-gray-500 text-sm tracking-wide">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/staff/login" replace />;
  }

  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  // Routing is driven by account_domain + active_portal, not role. A MANAGEMENT-domain
  // account currently viewing "My Staff Portal" is routed to /employee even though their
  // role still carries management permissions - the backend enforces the same rule.
  if (area === "management" && (user.account_domain !== "MANAGEMENT" || user.active_portal !== "MANAGEMENT")) {
    return <Navigate to="/employee" replace />;
  }

  if (area === "employee" && user.active_portal !== "STAFF") {
    return <Navigate to={getLandingRouteForUser(user)} replace />;
  }

  return children;
};
